module.exports = __webpack_public_path__ + "img/sarah-1000x1000.51c3764e.jpg";